import { render, staticRenderFns } from "./ImgDeal.vue?vue&type=template&id=22d99f98&scoped=true"
import script from "./ImgDeal.vue?vue&type=script&lang=js"
export * from "./ImgDeal.vue?vue&type=script&lang=js"
import style0 from "./ImgDeal.vue?vue&type=style&index=0&id=22d99f98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d99f98",
  null
  
)

export default component.exports